<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
            <b-form @submit.prevent="handleSubmit(handleUpdate)"> 
                <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                    <template v-slot:header>
                        <p class="mb-0" style="font-size: 21px"><b>Editar Invitación</b></p>
                    </template>
                    <b-card-text>
                        <b-alert show variant="danger" v-if="errores">
                            <ul>
                                <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                            </ul>
                        </b-alert>
                        <b-row>
                            <b-col cols="12" md="4">
                                <b-form-group label="NIT:" label-for="formDataNit">
                                    <b-form-input
                                        id="formDataNit"
                                        v-model="formData.nit"
                                        disabled
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="8">
                                <b-form-group label="Nombre:" label-for="formDataName">
                                    <b-form-input
                                        id="formDataName"
                                        v-model="formData.name"
                                        disabled
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="12">
                                <ValidationProvider name="Email del contacto" rules="required|email" v-slot="{ errors, valid }">
                                    <b-form-group label="Email:" label-for="formDataEmail">
                                        <b-form-input
                                            id="formDataEmail"
                                            v-model="formData.email"
                                            type="text"
                                            autocomplete="off"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el email"
                                        />
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card-text>
                    <template v-slot:footer>
                        <b-button variant="danger" class="mr-2" @click.prevent="back">
                            Cancelar
                        </b-button>
                        <b-button variant="success" :disabled="invalid" type="submit">
                            Actualizar
                        </b-button>
                    </template>
                </b-card>
            </b-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { mapMutations } from 'vuex';

export default {
    name: 'ChatbotInvitationUpdate',

    components: { ValidationProvider },

    data() {
        return {
            formData: {
                id:    this.$route.params.invitation?.id    || '',
                nit:   this.$route.params.invitation?.nit   || '',
                name:  this.$route.params.invitation?.name  || '',
                email: this.$route.params.invitation?.email || '',
            },
            errors:  {},
            errores: false,
        }
    },

    methods: {
        ...mapMutations(['setLoading']),

        back() {
            this.$router.go(-1);
        },

        async handleUpdate() {
            this.errors  = {};
            this.errores = false;
            this.setLoading(true);

            await this.$conectar.put(`/admin/chatbot-invitations/update/${this.formData.id}`, {
                email: this.formData.email,
            })
            .then(response => {
                if (response.data.error == true) {
                    this.errores = true;
                    this.errors  = response.data.errors;
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'success',
                        solid:   true
                    });
                    this.$router.push({ name: 'chatbot-invitations.index' });
                }
            })
            .catch(() => {
                this.$root.$bvToast.toast('Error en el servidor, favor intente nuevamente más tarde', {
                    title:   'Respuesta del servidor',
                    variant: 'danger',
                    solid:   true
                });
            });

            this.setLoading(false);
        }
    }
}
</script>